import { render, staticRenderFns } from "./TechBroker.vue?vue&type=template&id=08891747&"
import script from "./TechBroker.vue?vue&type=script&lang=js&"
export * from "./TechBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports